/* eslint-disable */
import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Acl } from 'modules/common/components/Acl';
import SideScrollingTab from 'modules/common/components/SideScrollingTab';
import { getJson } from 'session';
import emptyStateImage from 'assets/img/icn-empty-state.svg';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import BusinessActivitiesContainer from '../components/business-activities/container/BusinessActivitiesContainer';
import TaxPayer from './TaxPayer';
import PermitApplication from './PermitApplication';
import BusinessOperation from './BusinessOperation';
// import { ucwords } from '../../../applications/helper';

import * as actions from '../action';
import * as c from '../constant';
import TaxCreditList from '../components/TaxCreditList';

function NewBusinessesContent({
  handleAddModal,
  handleEdit,
  handleRemove,
  newBusinessesId,
  getSingleNewBusinesses,
  newBusinessesInfo,

  // getNewBusinessActivitiesList,
  // newBusinessActivitiesList,
  handleHoldOnHold,
  ordinanceRevisionId,
  handleLogs,
  handleAddTaxCredit,

  handleOnRevertBusiness,
  handleOnRetireBusiness,
  handleUpdateVeterinary,
  handleUpdateBaseLine,
}) {
  const permissions = getJson('permissions');

  // eslint-disable-next-line no-unused-vars
  const [isRetired, setIsRetired] = useState(null);

  useEffect(() => {
    if (_.isEmpty(newBusinessesId)) return;
    getSingleNewBusinesses(newBusinessesId);
    // getNewBusinessActivitiesList(newBusinessesId);
  }, []);

  useEffect(() => {
    if (_.isEmpty(newBusinessesId)) return;
    getSingleNewBusinesses(newBusinessesId);
  }, [isRetired]);

  useEffect(() => {
    if (_.isEmpty(newBusinessesId)) return;
    getSingleNewBusinesses(newBusinessesId);
    // getNewBusinessActivitiesList(newBusinessesId);
  }, [newBusinessesId]);

  const taxPayer = _.get(newBusinessesInfo, 'included.taxPayer.attributes');
  const permitApplication = _.get(
    newBusinessesInfo,
    'included.permitApplications'
  );
  const taxCredit = _.get(newBusinessesInfo, 'included.taxCredits') || [];

  return (
    <div className="container-fluid card-section-content">
      <div className="card-body">
        <div className="row pb-2 bg-white">
          <div className="col-12 d-flex">
            {Acl(permissions, ['ADD BUSINESS']) && (
              <button
                type="button"
                onClick={handleAddModal}
                className="btn btn-primary cms-bg-color-primary cms-outline-primary  font-weight-bold px-4 ml-auto   "
              >
                Add Business &nbsp;&nbsp;
                <i className="fas fa-plus" />
              </button>
            )}
          </div>
        </div>
        {!_.isEmpty(newBusinessesInfo) ? (
          <React.Fragment>
            <div className="row bg-white">
              <div className="col">
                <h2 className="">
                  {_.get(newBusinessesInfo, 'attributes.business_name')}
                </h2>
                <p className="label-secondary">
                  BIN: &nbsp;
                  {_.get(newBusinessesInfo, 'attributes.bin') || '0'}
                </p>
              </div>
            </div>
            <div className="row justify-content-end mb-3 mr-0">
              <div className="m-2">
                {Acl(permissions, ['ADD BUSINESS TAX CREDIT']) &&
                _.get(newBusinessesInfo, 'attributes.is_retired') === 0 && ( // unhide button if retire status === 0
                    <button
                      type="button"
                      onClick={handleAddTaxCredit(newBusinessesInfo)}
                      className="btn btn-primary cms-bg-color-primary cms-outline-primary  font-weight-bold   "
                    >
                      Add Tax Credit &nbsp;&nbsp;
                      <i className="fas fa-plus" />
                    </button>
                  )}
              </div>
              <div className="m-2">
                {Acl(permissions, ['VIEW BPLS LOGS']) && (
                  <button
                    type="button"
                    className="btn btn-primary cms-bg-color-primary cms-outline-primary  font-weight-bold   "
                    onClick={handleLogs(newBusinessesInfo)}
                  >
                    Logs
                  </button>
                )}
              </div>
              {((!_.get(newBusinessesInfo, 'attributes.is_hold') &&
                Acl(permissions, ['HOLD BUSINESS'])) ||
                (_.get(newBusinessesInfo, 'attributes.is_hold') &&
                  Acl(permissions, ['UNHOLD BUSINESS']))) &&
              _.get(newBusinessesInfo, 'attributes.is_retired') === 0 && ( // unhide button if retire status === 0
                  <div className="m-2">
                    <button
                      type="button"
                      onClick={handleHoldOnHold(newBusinessesInfo)}
                      className={`btn ${
                        _.get(newBusinessesInfo, 'attributes.is_hold')
                          ? 'btn-primary cms-bg-color-primary cms-outline-primary '
                          : 'btn-danger'
                      } font-weight-bold`}
                    >
                      {_.get(newBusinessesInfo, 'attributes.is_hold')
                        ? 'Unhold'
                        : 'Hold'}
                    </button>
                  </div>
                )}
              {Acl(permissions, ['BPLS BUSINESS RETIRE']) &&
                _.get(newBusinessesInfo, 'attributes.is_retired') === 0 && (
                  <div className="m-2">
                    <button
                      type="button"
                      onClick={handleOnRetireBusiness(newBusinessesInfo)}
                      className="btn btn-primary cms-bg-color-primary cms-outline-primary  font-weight-bold"
                    >
                      Retire
                    </button>
                  </div>
                )}
              {Acl(permissions, ['BPLS BUSINESS RETIRE']) &&
                _.get(newBusinessesInfo, 'attributes.is_retired') === 1 && (
                  <div className="m-2">
                    <button
                      type="button"
                      onClick={handleOnRevertBusiness(newBusinessesInfo)}
                      className="btn btn-danger font-weight-bold"
                    >
                      Unretire
                    </button>
                  </div>
                )}
              {Acl(permissions, ['BPLS BUSINESS VETERINARY UPDATE']) &&
                !_.get(newBusinessesInfo, 'attributes.is_retired') && (
                  <div className="m-2">
                    <button
                      type="button"
                      className="btn btn-primary cms-bg-color-primary cms-outline-primary font-weight-bold"
                      onClick={handleUpdateVeterinary(newBusinessesInfo)}
                    >
                      Update Veterinary
                    </button>
                  </div>
                )}
              {Acl(permissions, ['BPLS BUSINESS BASELINE UPDATE']) &&
                !_.get(newBusinessesInfo, 'attributes.is_retired') && (
                  <div className="m-2">
                    <button
                      type="button"
                      className="btn btn-primary cms-bg-color-primary cms-outline-primary font-weight-bold"
                      onClick={handleUpdateBaseLine(newBusinessesInfo)}
                    >
                      Update Base Line
                    </button>
                  </div>
                )}
              {Acl(permissions, ['EDIT BUSINESS']) &&
              _.get(newBusinessesInfo, 'attributes.is_retired') === 0 && ( // unhide button if retire status === 0
                  <div className="mx-0 mt-2">
                    <button
                      type="button"
                      className="btn-blank"
                      onClick={handleEdit(newBusinessesInfo)}
                    >
                      <i className="far fa-edit icon-edit" />
                    </button>
                  </div>
                )}
              {Acl(permissions, ['DELETE BUSINESS']) &&
              _.get(newBusinessesInfo, 'attributes.is_retired') === 0 && ( // unhide button if retire status === 0
                  <div className="mx-0 mt-2">
                    <button
                      type="button"
                      className="btn-blank"
                      onClick={handleRemove(newBusinessesInfo)}
                    >
                      <i className="far fa-trash-alt icon-delete" />
                    </button>
                  </div>
                )}
            </div>
            <div>
              <Tabs>
                <SideScrollingTab dragToScroll>
                  <TabList>
                    <Tab>Business Information</Tab>
                    <Tab>Account</Tab>
                    <Tab>Business Operation</Tab>
                    <Tab>Business Activities</Tab>
                    {/* <Tab>Tax Payer</Tab> */}
                    <Tab>Applications</Tab>
                    <Tab>Tax Credit</Tab>
                  </TabList>
                </SideScrollingTab>
                <TabPanel>
                  <div className="card-body">
                    <div className="row bg-white pb-3">
                      <div className="col-12">
                        <div className="border rounded p-3 mb-3">
                          <table className="transaction-table table table-borderless table-sm">
                            <tbody>
                              <tr>
                                <td className="text-dark" width="250">
                                  Kind of Ownership
                                </td>
                                <td className="text-dark" width="1">
                                  :
                                </td>
                                <td colSpan={4}>
                                  <b>
                                    {_.get(
                                      newBusinessesInfo,
                                      'attributes.kind_of_ownership'
                                    ) || '-'}
                                  </b>
                                </td>
                              </tr>
                              {(_.get(
                                newBusinessesInfo,
                                'attributes.kind_of_ownership'
                              ) === 'SOLE PROPRIETORSHIP' ||
                                _.get(
                                  newBusinessesInfo,
                                  'attributes.kind_of_ownership'
                                ) === 'ONE PERSON CORPORATION') && (
                                <tr>
                                  <td className="text-dark" width="250">
                                    Owners Gender
                                  </td>
                                  <td className="text-dark" width="1">
                                    :
                                  </td>
                                  <td colSpan={4}>
                                    <b>
                                      {_.get(
                                        newBusinessesInfo,
                                        'attributes.owners_gender'
                                      ) === 'M'
                                        ? 'Male'
                                        : 'Female' || '-'}
                                    </b>
                                  </td>
                                </tr>
                              )}
                              {_.get(
                                newBusinessesInfo,
                                'attributes.kind_of_ownership'
                              ) === 'SOLE PROPRIETORSHIP' && (
                                <tr>
                                  <td className="text-dark" width="250">
                                    DTI Registration Number
                                  </td>
                                  <td className="text-dark" width="1">
                                    :
                                  </td>
                                  <td colSpan={4}>
                                    <b>
                                      {_.get(
                                        newBusinessesInfo,
                                        'attributes.dti_no'
                                      ) || '-'}
                                    </b>
                                  </td>
                                </tr>
                              )}
                              {(_.get(
                                newBusinessesInfo,
                                'attributes.kind_of_ownership'
                              ) === 'CORPORATION' ||
                                _.get(
                                  newBusinessesInfo,
                                  'attributes.kind_of_ownership'
                                ) === 'PARTNERSHIP' ||
                                _.get(
                                  newBusinessesInfo,
                                  'attributes.kind_of_ownership'
                                ) === 'ONE PERSON CORPORATION') && (
                                <tr>
                                  <td className="text-dark" width="250">
                                    SEC Registration Number
                                  </td>
                                  <td className="text-dark" width="1">
                                    :
                                  </td>
                                  <td colSpan={4}>
                                    <b>
                                      {_.get(
                                        newBusinessesInfo,
                                        'attributes.sec_no'
                                      ) || '-'}
                                    </b>
                                  </td>
                                </tr>
                              )}
                              {_.get(
                                newBusinessesInfo,
                                'attributes.kind_of_ownership'
                              ) === 'COOPERATIVE' && (
                                <tr>
                                  <td className="text-dark" width="250">
                                    CDA Registration Number
                                  </td>
                                  <td className="text-dark" width="1">
                                    :
                                  </td>
                                  <td colSpan={4}>
                                    <b>
                                      {_.get(
                                        newBusinessesInfo,
                                        'attributes.cda_no'
                                      ) || '-'}
                                    </b>
                                  </td>
                                </tr>
                              )}
                              <tr>
                                <td className="text-dark" width="250">
                                  TIN
                                </td>
                                <td className="text-dark" width="1">
                                  :
                                </td>
                                <td colSpan={4}>
                                  <b>
                                    {_.get(
                                      newBusinessesInfo,
                                      'attributes.tin_no'
                                    ) || '-'}
                                  </b>
                                </td>
                              </tr>
                              <tr>
                                <td className="text-dark" width="250">
                                  Business Name
                                </td>
                                <td className="text-dark" width="1">
                                  :
                                </td>
                                <td colSpan={4}>
                                  <b>
                                    {_.get(
                                      newBusinessesInfo,
                                      'attributes.business_name'
                                    ) || '-'}
                                  </b>
                                </td>
                              </tr>
                              <tr>
                                <td className="text-dark" width="250">
                                  Trade Name/Franchise (if applicable)
                                </td>
                                <td className="text-dark" width="1">
                                  :
                                </td>
                                <td colSpan={4}>
                                  <b>
                                    {_.get(
                                      newBusinessesInfo,
                                      'attributes.trade_name'
                                    ) || '-'}
                                  </b>
                                </td>
                              </tr>
                              <tr>
                                <td className="text-dark" width="250">
                                  Business Address
                                </td>
                                <td className="text-dark" width="1">
                                  :
                                </td>
                                <td colSpan={4}>
                                  <b>
                                    {_.get(
                                      newBusinessesInfo,
                                      'attributes.main_office_display_address'
                                    ) || '-'}
                                  </b>
                                </td>
                              </tr>
                              <tr>
                                <td className="text-dark" width="250">
                                  Telephone Number
                                </td>
                                <td className="text-dark" width="1">
                                  :
                                </td>
                                <td colSpan={4}>
                                  <b>
                                    {_.get(
                                      newBusinessesInfo,
                                      'attributes.telephone_no'
                                    ) || '-'}
                                  </b>
                                </td>
                              </tr>
                              <tr>
                                <td className="text-dark" width="250">
                                  Mobile Number
                                </td>
                                <td className="text-dark" width="1">
                                  :
                                </td>
                                <td colSpan={4}>
                                  <b>
                                    {_.get(
                                      newBusinessesInfo,
                                      'attributes.cellphone_no'
                                    ) || '-'}
                                  </b>
                                </td>
                              </tr>
                              <tr>
                                <td className="text-dark" width="250">
                                  Email Address
                                </td>
                                <td className="text-dark" width="1">
                                  :
                                </td>
                                <td colSpan={4}>
                                  <b>
                                    {_.get(
                                      newBusinessesInfo,
                                      'attributes.email_address'
                                    ) || '-'}
                                  </b>
                                </td>
                              </tr>
                              {_.get(
                                newBusinessesInfo,
                                'attributes.kind_of_ownership'
                              ) === 'SOLE PROPRIETORSHIP' && (
                                <tr>
                                  <td className="text-dark" width="250">
                                    Name of Owner
                                  </td>
                                  <td className="text-dark" width="1">
                                    :
                                  </td>
                                  <td colSpan={4}>
                                    <b>
                                      {_.get(
                                        newBusinessesInfo,
                                        'attributes.owners_display_name'
                                      ) || '-'}
                                    </b>
                                  </td>
                                </tr>
                              )}
                              {(_.get(
                                newBusinessesInfo,
                                'attributes.kind_of_ownership'
                              ) === 'CORPORATION' ||
                                _.get(
                                  newBusinessesInfo,
                                  'attributes.kind_of_ownership'
                                ) === 'COOPERATIVE' ||
                                _.get(
                                  newBusinessesInfo,
                                  'attributes.kind_of_ownership'
                                ) === 'PARTNERSHIP') && (
                                <>
                                  <tr>
                                    <td className="text-dark" width="250">
                                      Name of President / Officer In Charge
                                    </td>
                                    <td className="text-dark" width="1">
                                      :
                                    </td>
                                    <td colSpan={4}>
                                      <b>
                                        {_.get(
                                          newBusinessesInfo,
                                          'attributes.owners_display_name'
                                        ) || '-'}
                                      </b>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td className="text-dark" width="250">
                                      Nationality
                                    </td>
                                    <td className="text-dark" width="1">
                                      :
                                    </td>
                                    <td colSpan={4}>
                                      <b>
                                        {_.get(
                                          newBusinessesInfo,
                                          'attributes.nationality'
                                        ) || '-'}
                                      </b>
                                    </td>
                                  </tr>
                                </>
                              )}
                              <tr>
                                <td className="text-dark" width="250">
                                  Business Status
                                </td>
                                <td className="text-dark" width="1">
                                  :
                                </td>
                                <td colSpan={4}>
                                  {(_.get(
                                    newBusinessesInfo,
                                    'attributes.is_hold'
                                  ) === 1 && <b>HOLD</b>) ||
                                    (_.get(
                                      newBusinessesInfo,
                                      'attributes.is_retired'
                                    ) === 1 && <b>RETIRED</b>) ||
                                    (_.get(
                                      newBusinessesInfo,
                                      'attributes.is_hold'
                                    ) === 0 &&
                                      _.get(
                                        newBusinessesInfo,
                                        'attributes.is_retired'
                                      ) === 0 && <b>ACTIVE</b>)}
                                </td>
                              </tr>
                              <tr>
                                <td className="text-dark" width="250">
                                  Remarks
                                </td>
                                <td className="text-dark" width="1">
                                  :
                                </td>
                                <td colSpan={4}>
                                  <b>
                                    {_.get(
                                      newBusinessesInfo,
                                      'attributes.hold_remarks'
                                    ) || '-'}
                                  </b>
                                </td>
                              </tr>

                              {/* {Object.entries(
                                _.get(newBusinessesInfo, 'attributes.details')
                              ).map(item => {
                                return (
                                  <React.Fragment
                                    key={`bpls_business_detail${item[0]}`}
                                  >
                                    <tr>
                                      <td className="text-dark" width="250">
                                        {ucwords(
                                          item[0].replace(/_/g, ' ') || '-'
                                        )}
                                      </td>
                                      <td className="text-dark" width="1">
                                        :
                                      </td>
                                      <td colSpan={4}>
                                        <b>{item[1] || '-'}</b>
                                      </td>
                                    </tr>
                                  </React.Fragment>
                                );
                              }) || ''} */}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </TabPanel>
                <TabPanel>
                  <div>
                    <TaxPayer
                      taxPayer={taxPayer}
                      newBusinessesInfo={newBusinessesInfo}
                      ordinanceRevisionId={ordinanceRevisionId}
                    />
                  </div>
                </TabPanel>
                <TabPanel>
                  <div>
                    <BusinessOperation newBusinessesInfo={newBusinessesInfo} />
                  </div>
                </TabPanel>
                <TabPanel>
                  <div>
                    <BusinessActivitiesContainer
                      newBusinessesId={newBusinessesId}
                      // newBusinessActivitiesList={newBusinessActivitiesList}
                      newBusinessesInfo={newBusinessesInfo}
                      setIsRetired={setIsRetired}
                    />
                  </div>
                </TabPanel>
                {/* <TabPanel>
                  <div>
                    <TaxPayer taxPayer={taxPayer} />
                  </div>
                </TabPanel> */}
                <TabPanel>
                  <div>
                    <PermitApplication permitApplication={permitApplication} />
                  </div>
                </TabPanel>
                <TabPanel>
                  <TaxCreditList
                    data={taxCredit}
                    businessId={newBusinessesInfo.id}
                  />
                </TabPanel>
              </Tabs>
            </div>
          </React.Fragment>
        ) : (
          <div className="d-flex align-items-center justitfy-content-center h-100">
            <div className="text-center mx-auto py-4">
              <img
                src={emptyStateImage}
                className="img-responsive image-wrapper mb-4 mt-3"
                alt="Empty State"
              />
              <p className="emp-title mb-0"> No Item Found </p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

NewBusinessesContent.propTypes = {
  handleAddModal: PropTypes.instanceOf(Function).isRequired,
  handleEdit: PropTypes.instanceOf(Function).isRequired,
  handleRemove: PropTypes.instanceOf(Function).isRequired,

  getSingleNewBusinesses: PropTypes.instanceOf(Function).isRequired,
  newBusinessesInfo: PropTypes.instanceOf(Object).isRequired,
  newBusinessesId: PropTypes.string.isRequired,

  // getNewBusinessActivitiesList: PropTypes.instanceOf(Function).isRequired,
  // newBusinessActivitiesList: PropTypes.instanceOf(Array).isRequired,
  handleHoldOnHold: PropTypes.instanceOf(Function).isRequired,
  handleLogs: PropTypes.instanceOf(Function).isRequired,
  ordinanceRevisionId: PropTypes.number.isRequired,
  handleAddTaxCredit: PropTypes.instanceOf(Function).isRequired,

  handleOnRevertBusiness: PropTypes.instanceOf(Function).isRequired,
  handleOnRetireBusiness: PropTypes.instanceOf(Function).isRequired,
  handleUpdateVeterinary: PropTypes.instanceOf(Function).isRequired,
  handleUpdateBaseLine: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }, { match }) => ({
  newBusinessesInfo: _.get(api, `${c.GET_SINGLE_NEW_BUSINESSES}.item`) || {},
  newBusinessesId: _.get(match, 'params.newBusinessesId') || '',

  // newBusinessActivitiesList:
  //   _.get(api, `${c.GET_NEW_BUSINESS_ACTIVITIES}.list`) || [],
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(NewBusinessesContent);
